function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Row, UncontrolledDropdown } from "reactstrap";
import classNames from "classnames";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory, { PaginationListStandalone, PaginationProvider, PaginationTotalStandalone, SizePerPageDropdownStandalone } from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import { defaultPaginationOptions, noPaginationOptions } from "../../../helpers/tableUtils";
import BlankSpace from "../styled/BlankSpace";

class GeneralTable extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      const customTotal = (from, to, size) => /*#__PURE__*/React.createElement("label", {
        className: "react-bootstrap-table-pagination-total ml-2"
      }, "Showing ", from, " to ", to, " of ", size);

      const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
      }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
        className: "d-inline mr-1"
      }, "Display"), /*#__PURE__*/React.createElement(UncontrolledDropdown, {
        className: "d-inline dropdown-sm"
      }, /*#__PURE__*/React.createElement(DropdownToggle, {
        caret: true,
        tag: "button",
        type: "button",
        className: "btn btn-outline-secondary btn-sm"
      }, currSizePerPage), /*#__PURE__*/React.createElement(DropdownMenu, null, options.map((option, idx) => /*#__PURE__*/React.createElement(DropdownItem, {
        key: idx,
        type: "button",
        className: classNames({
          active: currSizePerPage + '' === option.page + ''
        }),
        onClick: () => onSizePerPageChange(option.page)
      }, option.text)))));

      const renderSearch = props => {
        if (!!this.props.hideTopTool) {
          return /*#__PURE__*/React.createElement(BlankSpace, null);
        }

        return /*#__PURE__*/React.createElement(Row, {
          className: "mt-2"
        }, /*#__PURE__*/React.createElement(Col, {
          md: 12,
          sm: 12
        }, /*#__PURE__*/React.createElement(Form, {
          inline: true,
          className: "mb-2 float-left"
        }, /*#__PURE__*/React.createElement(FormGroup, {
          className: "mb-2 mr-sm-2 mb-sm-0"
        }, /*#__PURE__*/React.createElement(SearchBar, props.searchProps))), /*#__PURE__*/React.createElement("div", {
          className: "mb-2 float-right"
        }, this.props.topTool)));
      };

      const {
        SearchBar
      } = Search;

      const renderPagination = paginationProps => {
        if (!!this.props.hidePagination) {
          // return <BlankSpace />;
          return /*#__PURE__*/React.createElement("div", null);
        }

        return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(SizePerPageDropdownStandalone, paginationProps), /*#__PURE__*/React.createElement(PaginationTotalStandalone, _extends({}, paginationProps, {
          dataSize: this.props.data.length
        }))), /*#__PURE__*/React.createElement(Col, {
          className: "react-bootstrap-table-pagination-list"
        }, /*#__PURE__*/React.createElement(PaginationListStandalone, paginationProps)));
      };

      return /*#__PURE__*/React.createElement(PaginationProvider, {
        bootstrap4: true,
        pagination: paginationFactory({ ...defaultPaginationOptions,
          ...this.props.paginationOptions,
          ...noPaginationOptions(this.props.hidePagination),
          paginationTotalRenderer: customTotal,
          custom: true,
          sizePerPageRenderer: sizePerPageRenderer
        }),
        keyField: "id",
        data: this.props.data,
        columns: this.props.columns
      }, ({
        paginationProps,
        paginationTableProps
      }) => /*#__PURE__*/React.createElement(ToolkitProvider, {
        bootstrap4: true,
        keyField: "id",
        data: this.props.data,
        columns: this.props.columns,
        search: true
      }, props => /*#__PURE__*/React.createElement(React.Fragment, null, renderSearch(props), /*#__PURE__*/React.createElement("div", {
        className: classNames(!!this.props.hideHeader ? 'table-no-header' : '', !!this.props.largeDataSet ? 'table-large-data-set' : ''),
        cypress: this.props.cypress
      }, /*#__PURE__*/React.createElement(BootstrapTable, _extends({}, props.baseProps, {
        bordered: this.props.bordered ? true : false,
        headerClasses: "thead-light",
        wrapperClasses: "table-responsive"
      }, paginationTableProps, {
        defaultSorted: this.props.defaultSorted || [{
          dataField: 'id',
          order: 'desc'
        }],
        expandRow: this.props.expandRow,
        hover: true
      }))), renderPagination(paginationProps))));
    });
  }

}

export default GeneralTable;